export const HOME = "/";
export const ABOUT_US = "/about-us";
export const CONTRACTS = "/our-contracts";
export const CONTACTUS = "/contact-us";
export const CLIENTS = "/clients";